import React, { useState, useEffect } from 'react'
import { useResponsive } from '../hooks/useResponsive.jsx'
import { 
  Home, 
  Calendar, 
  Heart, 
  Navigation, 
  Settings
} from 'lucide-react'

export const BottomNavigation = () => {
  const { isMobile } = useResponsive()
  const [activeSection, setActiveSection] = useState('dashboard')

  const bottomNavItems = [
    { name: 'Dashboard', href: '/dashboard', icon: Home, section: 'dashboard' },
    { name: 'Calendário', href: '/calendar', icon: Calendar, section: 'calendar' },
    { name: 'Localização', href: '/family-geo', icon: Navigation, section: 'family-geo' },
    { name: 'SOS', href: '/family-geo', icon: Heart, section: 'sos', isEmergency: true },
    { name: 'Mais', href: '/settings', icon: Settings, section: 'more' },
  ]

  if (!isMobile) {
    return null
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-30">
      <div className="flex items-center justify-around py-2">
        {bottomNavItems.map((item) => {
          const Icon = item.icon
          const isActive = activeSection === item.section
          
          return (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setActiveSection(item.section)}
              className={`
                flex flex-col items-center space-y-1 px-2 py-2 rounded-lg transition-colors duration-200
                ${isActive 
                  ? 'text-blue-600' 
                  : item.isEmergency 
                    ? 'text-red-600' 
                    : 'text-gray-600'
                }
              `}
            >
              <Icon className={`w-5 h-5 ${item.isEmergency ? 'animate-pulse' : ''}`} />
              <span className="text-xs font-medium">{item.name}</span>
            </a>
          )
        })}
      </div>
    </div>
  )
}

export const ResponsiveHeader = ({ title, showBackButton = false, onBackClick }) => {
  const { isMobile } = useResponsive()

  if (!isMobile) {
    return null
  }

  return (
    <div className="sticky top-0 z-20 bg-white border-b border-gray-200 px-4 py-3">
      <div className="flex items-center space-x-3">
        {showBackButton && (
          <button
            onClick={onBackClick}
            className="p-1 rounded-lg hover:bg-gray-100"
          >
            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        <h1 className="text-lg font-semibold text-gray-800 flex-1">{title}</h1>
      </div>
    </div>
  )
}

export const useNavigation = () => {
  const { isMobile } = useResponsive()
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile)
  const [activeSection, setActiveSection] = useState('dashboard')

  const navigateTo = (section) => {
    setActiveSection(section)
    if (isMobile) {
      setSidebarOpen(false)
    }
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  return {
    activeSection,
    setActiveSection,
    navigateTo,
    toggleSidebar,
    sidebarOpen,
    setSidebarOpen,
    isMobile
  }
}
